(() => {
  let counter = 0;
  let selector = ".bss-currency-wrapper, div:has(>#switcher)"
  const interval = setInterval(() => {
      if ($(selector).length > 0 && window.innerWidth > 768) {
        setTimeout(() => {
          const targetElement = document.querySelector(".utility-bar-right");
          const elementToInsert = document.querySelector(".bss-currency-wrapper, div:has(>#switcher)");
          
          if (targetElement && elementToInsert) {
              targetElement.insertAdjacentElement('afterbegin', elementToInsert);
          }
        }, 500)
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100);
})();

(() => {
  const isLoginPage = window.location.pathname.includes("account/login")
  if(isLoginPage) {
    let counter = 0;
    let selector = "#customer_register_link";
    const interval = setInterval(() => {
        if ($(selector).length > 0) {
          const textReg = $(selector).text();
            if(textReg === 'Create account'){
              $(selector).attr("href", "/en/pages/register")
            } else if(textReg === 'Créer un compte'){
               // $(selector).attr("href", "/fr/pages/formulaire-dinscription")
               $(selector).attr("href", "/fr/pages/register")
            } else if(textReg === 'Crea account'){
              // $(selector).attr("href", "/it/pages/modulo-di-registrazione")
              $(selector).attr("href", "/it/pages/register")
            } else if(textReg === 'Crear cuenta ') {
               $(selector).attr("href", "/pages/register")
            }
            clearInterval(interval);
        } else {
            counter += 100;
            if (counter >= 10000) {
                clearInterval(interval);
            }
        }
    }, 100);
  }
})()

// check RF form
const isRFForm = window.location.pathname.includes("/pages/register");
if(isRFForm) {
  let counter = 0;
  let selector = `#bss-b2b-register-form [type="submit"]`;
  const interval = setInterval(() => {
      if ($(selector).length > 0) {
       replaceButtonSubmit();
        setTimeout(() => {
          changePosInputAndLabel();
          handleClickCheckBox();
          chooseDefaultLang();
        }, 500)
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100);
}

function replaceButtonSubmit(){
  const inputElement = document.querySelector('input[type="submit"]');
  if (inputElement) {
    const buttonElement = document.createElement('button');
    buttonElement.type = 'submit';
    buttonElement.className = inputElement.className;
    buttonElement.textContent = inputElement.value;
    inputElement.parentNode.replaceChild(buttonElement, inputElement);
  }
}

function changePosInputAndLabel(){
  $('.bss-b2b-rf-field:not(.field-checkbox)').each((i,item) => {
    const input = $(item).find("input");
    const label = $(item).find("label");
    if(input && label) {
        input.after(label);
    }
  })
}

function handleClickCheckBox(){
  document.querySelector(".bss-b2b-rf-field.field-checkbox label").addEventListener("click", function() {
    this.parentNode.querySelector(`[type="checkbox"]`).click()
  })
}

function chooseDefaultLang(){
  const langChar = {
    '/en/pages/register' : 'English',
    '/fr/pages/register' : 'Français',
    '/it/pages/register' : 'Italiano',
    '/pages/register' : 'Español',
  }
  $(`.field-select option[value='${langChar[window.location.pathname]}']`).prop("selected", "selected")
}

$(`label[for="accepts-marketing"]`).click()
let counter1 = 0;
let selector1 = `label[for="accepts-marketing"]`;
const interval1 = setInterval(() => {
    if ($(selector1).length > 0) {
      setTimeout(() => {
        const checkbox = document.getElementById('accepts-marketing');
      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
      }, 500)
        clearInterval(interval1);
    } else {
        counter1 += 100;
        if (counter1 >= 10000) {
            clearInterval(interval1);
        }
    }
}, 100);


if(typeof BSS_B2B !== "undefined") {
  let counter = 0;
const interval = setInterval(() => {
    if ($("#country-list").length) {
        translateCountry();
        clearInterval(interval);
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);
function translateCountry(){
  const countryNames = {
    en: {
      "AF": "Afghanistan",
      "AX": "Åland Islands",
      "AL": "Albania",
      "DZ": "Algeria",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguilla",
      "AG": "Antigua and Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Ascension",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaijan",
      "BS": "Bahamas",
      "BH": "Bahrain",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Belarus",
      "BE": "Belgium",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BA": "Bosnia and Herzegovina",
      "BW": "Botswana",
      "BV": "Bouvet Island",
      "BR": "Brazil",
      "IO": "British Indian Ocean Territory",
      "VG": "British Virgin Islands",
      "BN": "Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodia",
      "CM": "Cameroon",
      "CA": "Canada",
      "CV": "Cape Verde",
      "BQ": "Caribbean Netherlands",
      "KY": "Cayman Islands",
      "CF": "Central African Republic",
      "TD": "Chad",
      "CL": "Chile",
      "CN": "China",
      "CX": "Christmas Island",
      "CC": "Cocos (Keeling) Islands",
      "CO": "Colombia",
      "KM": "Comoros",
      "CG": "Congo - Brazzaville",
      "CD": "Congo - Kinshasa",
      "CK": "Cook Islands",
      "CR": "Costa Rica",
      "CI": "Ivory Coast",
      "HR": "Croatia",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Cyprus",
      "CZ": "Czech Republic",
      "DK": "Denmark",
      "DJ": "Djibouti",
      "DM": "Dominica",
      "DO": "Dominican Republic",
      "EC": "Ecuador",
      "EG": "Egypt",
      "SV": "El Salvador",
      "GQ": "Equatorial Guinea",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Ethiopia",
      "FK": "Falkland Islands",
      "FO": "Faroe Islands",
      "FJ": "Fiji",
      "FI": "Finland",
      "FR": "France",
      "GF": "French Guiana",
      "PF": "French Polynesia",
      "TF": "French Southern Territories",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germany",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Greece",
      "GL": "Greenland",
      "GD": "Grenada",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bissau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Heard and McDonald Islands",
      "HN": "Honduras",
      "HK": "Hong Kong SAR",
      "HU": "Hungary",
      "IS": "Iceland",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran",
      "IQ": "Iraq",
      "IE": "Ireland",
      "IM": "Isle of Man",
      "IL": "Israel",
      "IT": "Italy",
      "JM": "Jamaica",
      "JP": "Japan",
      "JE": "Jersey",
      "JO": "Jordan",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kyrgyzstan",
      "LA": "Laos",
      "LV": "Latvia",
      "LB": "Lebanon",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libya",
      "LI": "Liechtenstein",
      "LT": "Lithuania",
      "LU": "Luxembourg",
      "MO": "Macau SAR China",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaysia",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malta",
      "MQ": "Martinique",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "MX": "Mexico",
      "MD": "Moldova",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Morocco",
      "MZ": "Mozambique",
      "MM": "Myanmar (Burma)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Netherlands",
      "AN": "Netherlands Antilles",
      "NC": "New Caledonia",
      "NZ": "New Zealand",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Norfolk Island",
      "KP": "North Korea",
      "MK": "North Macedonia",
      "NO": "Norway",
      "OM": "Oman",
      "PK": "Pakistan",
      "PS": "Palestinian Territories",
      "PA": "Panama",
      "PG": "Papua New Guinea",
      "PY": "Paraguay",
      "PE": "Peru",
      "PH": "Philippines",
      "PN": "Pitcairn Islands",
      "PL": "Poland",
      "PT": "Portugal",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Romania",
      "RU": "Russia",
      "RW": "Rwanda",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé and Príncipe",
      "SA": "Saudi Arabia",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten",
      "SK": "Slovakia",
      "SI": "Slovenia",
      "SB": "Solomon Islands",
      "SO": "Somalia",
      "ZA": "South Africa",
      "KR": "South Korea",
      "SS": "South Sudan",
      "ES": "Spain",
      "LK": "Sri Lanka",
      "SD": "Sudan",
      "SR": "Suriname",
      "SJ": "Svalbard and Jan Mayen",
      "SE": "Sweden",
      "CH": "Switzerland",
      "SY": "Syria",
      "TW": "Taiwan",
      "TJ": "Tajikistan",
      "TZ": "Tanzania",
      "TH": "Thailand",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad and Tobago",
      "TN": "Tunisia",
      "TR": "Turkey",
      "TM": "Turkmenistan",
      "TC": "Turks and Caicos Islands",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ukraine",
      "AE": "United Arab Emirates",
      "GB": "United Kingdom",
      "US": "United States",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Vatican City",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis and Futuna",
      "EH": "Western Sahara",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    },
    es: {
    "AF": "Afganistán",
    "AL": "Albania",
    "DE": "Alemania",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguila",
    "AG": "Antigua y Barbuda",
    "DZ": "Argelia",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AC": "Ascensión",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaiyán",
    "AN": "Antillas Neerlandesas",
    "BS": "Bahamas",
    "BH": "Bahréin",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Bielorrusia",
    "BE": "Bélgica",
    "BZ": "Belice",
    "MM": "Birmania (Myanmar)",
    "BJ": "Benín",
    "BM": "Bermuda",
    "BT": "Bután",
    "BO": "Bolivia",
    "BA": "Bosnia y Herzegovina",
    "BW": "Botsuana",
    "BR": "Brasil",
    "BN": "Brunéi",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "KR": "Corea del Sur",
    "KH": "Camboya",
    "CM": "Camerún",
    "CA": "Canadá",
    "CV": "Cabo Verde",
    "VA": "Ciudad del Vaticano",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CO": "Colombia",
    "KM": "Comoras",
    "KP": "Corea del Norte",
    "CG": "Congo - Brazzaville",
    "CD": "Congo - Kinshasa",
    "CR": "Costa Rica",
    "CI": "Costa de Marfil",
    "HR": "Croacia",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Chipre",
    "DK": "Dinamarca",
    "DM": "Dominica",
    "EC": "Ecuador",
    "EG": "Egipto",
    "SV": "El Salvador",
    "ER": "Eritrea",
    "ES": "España",
    "EE": "Estonia",
    "SZ": "Eswatini",
    "ET": "Etiopía",
    "SK": "Eslovaquia",
    "SI": "Eslovenia",
    "AE": "Emiratos Árabes Unidos",
    "US": "Estados Unidos",
    "FJ": "Fiyi",
    "FI": "Finlandia",
    "PH": "Filipinas",
    "FR": "Francia",
    "GF": "Guayana Francesa",
    "GA": "Gabón",
    "GM": "Gambia",
    "GE": "Georgia",
    "GH": "Ghana",
    "GQ": "Guinea Ecuatorial",
    "GI": "Gibraltar",
    "GR": "Grecia",
    "GL": "Groenlandia",
    "GD": "Granada",
    "GP": "Guadalupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bisáu",
    "GY": "Guyana",
    "HT": "Haití",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungría",
    "HM": "Islas Heard y McDonald",
    "CX": "Isla de Navidad",
    "CC": "Islas Cocos (Keeling)",
    "BV": "Isla Bouvet",
    "IS": "Islandia",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Irán",
    "IQ": "Irak",
    "IE": "Irlanda",
    "NF": "Isla Norfolk",
    "IM": "Isla de Man",
    "KY": "Islas Caimán",
    "FK": "Islas Malvinas",
    "FO": "Islas Feroe",
    "PN": "Islas Pitcairn",
    "TC": "Islas Turcas y Caicos",
    "SB": "Islas Salomón",
    "AX": "Islas Åland",
    "VG": "Islas Vírgenes Británicas",
    "CK": "Islas Cook",
    "IL": "Israel",
    "IT": "Italia",
    "JM": "Jamaica",
    "JP": "Japón",
    "JE": "Jersey",
    "JO": "Jordania",
    "KZ": "Kazajistán",
    "KE": "Kenia",
    "KI": "Kiribati",
    "XK": "Kosovo",
    "KW": "Kuwait",
    "KG": "Kirguistán",
    "LA": "Laos",
    "LV": "Letonia",
    "LB": "Líbano",
    "LS": "Lesoto",
    "LR": "Liberia",
    "LY": "Libia",
    "LI": "Liechtenstein",
    "LT": "Lituania",
    "LU": "Luxemburgo",
    "MO": "Macao (China)",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malasia",
    "MV": "Maldivas",
    "ML": "Malí",
    "MT": "Malta",
    "MQ": "Martinica",
    "MR": "Mauritania",
    "MU": "Mauricio",
    "YT": "Mayotte",
    "MX": "México",
    "MD": "Moldavia",
    "MC": "Mónaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Marruecos",
    "MZ": "Mozambique",
    "MK": "Macedonia del Norte",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NC": "Nueva Caledonia",
    "NZ": "Nueva Zelanda",
    "NI": "Nicaragua",
    "NE": "Níger",
    "NG": "Nigeria",
    "NU": "Niue",
    "NO": "Noruega",
    "OM": "Omán",
    "CZ": "República Checa",
    "DO": "República Dominicana",
    "NL": "Países Bajos",
    "PK": "Pakistán",
    "PA": "Panamá",
    "PG": "Papúa Nueva Guinea",
    "PY": "Paraguay",
    "PE": "Perú",
    "PL": "Polonia",
    "PT": "Portugal",
    "PF": "Polinesia Francesa",
    "QA": "Qatar",
    "RE": "Reunión",
    "RO": "Rumanía",
    "RU": "Rusia",
    "RW": "Ruanda",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Santo Tomé y Príncipe",
    "SA": "Arabia Saudita",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leona",
    "SG": "Singapur",
    "SX": "Sint Maarten",
    "SO": "Somalia",
    "ZA": "Sudáfrica",
    "SS": "Sudán del Sur",
    "LK": "Sri Lanka",
    "SD": "Sudán",
    "SR": "Surinam",
    "SJ": "Svalbard y Jan Mayen",
    "SE": "Suecia",
    "CH": "Suiza",
    "SY": "Siria",
    "EH": "Sahara Occidental",
    "TW": "Taiwán",
    "IO": "Territorio Británico del Océano Índico",
    "PS": "Territorios Palestinos",
    "TJ": "Tayikistán",
    "TZ": "Tanzania",
    "TH": "Tailandia",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TF": "Territorios del Sur de Francia",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad y Tobago",
    "TN": "Túnez",
    "TR": "Turquía",
    "TM": "Turkmenistán",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ucrania",
    "UY": "Uruguay",
    "UZ": "Uzbekistán",
    "VU": "Vanuatu",
    "VE": "Venezuela",
    "VN": "Vietnam",
    "WF": "Wallis y Futuna",
    "YE": "Yemen",
    "DJ": "Yibuti",
    "ZM": "Zambia",
    "ZW": "Zimbabue"
  },
    it: {
      "AF": "Afghanistan",
      "AX": "Isole Åland",
      "AL": "Albania",
      "DZ": "Algeria",
      "AD": "Andorra",
      "AO": "Angola",
      "AI": "Anguila",
      "AG": "Antigua e Barbuda",
      "AR": "Argentina",
      "AM": "Armenia",
      "AW": "Aruba",
      "AC": "Ascensione",
      "AU": "Australia",
      "AT": "Austria",
      "AZ": "Azerbaigian",
      "BS": "Bahamas",
      "BH": "Bahrein",
      "BD": "Bangladesh",
      "BB": "Barbados",
      "BY": "Bielorussia",
      "BE": "Belgio",
      "BZ": "Belize",
      "BJ": "Benin",
      "BM": "Bermuda",
      "BT": "Bhutan",
      "BO": "Bolivia",
      "BA": "Bosnia ed Erzegovina",
      "BW": "Botswana",
      "BV": "Isola Bouvet",
      "BR": "Brasile",
      "IO": "Territorio Britannico dell'Oceano Indiano",
      "VG": "Isole Vergini Britanniche",
      "BN": "Brunei",
      "BG": "Bulgaria",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambogia",
      "CM": "Camerun",
      "CA": "Canada",
      "CV": "Capo Verde",
      "BQ": "Paesi Bassi Caraibici",
      "KY": "Isole Cayman",
      "CF": "Repubblica Centrafricana",
      "TD": "Ciad",
      "CL": "Cile",
      "CN": "Cina",
      "CX": "Isola di Natale",
      "CC": "Isole Cocos (Keeling)",
      "CO": "Colombia",
      "KM": "Comore",
      "CG": "Congo - Brazzaville",
      "CD": "Congo - Kinshasa",
      "CK": "Isole Cook",
      "CR": "Costa Rica",
      "CI": "Costa d'Avorio",
      "HR": "Croazia",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Cipro",
      "CZ": "Repubblica Ceca",
      "DK": "Danimarca",
      "DJ": "Gibuti",
      "DM": "Dominica",
      "DO": "Repubblica Dominicana",
      "EC": "Ecuador",
      "EG": "Egitto",
      "SV": "El Salvador",
      "GQ": "Guinea Equatoriale",
      "ER": "Eritrea",
      "EE": "Estonia",
      "SZ": "Eswatini",
      "ET": "Etiopia",
      "FK": "Isole Falkland",
      "FO": "Isole Færøer",
      "FJ": "Fiji",
      "FI": "Finlandia",
      "FR": "Francia",
      "GF": "Guiana Francese",
      "PF": "Polinesia Francese",
      "TF": "Territori Francesi del Sud",
      "GA": "Gabon",
      "GM": "Gambia",
      "GE": "Georgia",
      "DE": "Germania",
      "GH": "Ghana",
      "GI": "Gibilterra",
      "GR": "Grecia",
      "GL": "Groenlandia",
      "GD": "Grenada",
      "GP": "Guadalupa",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernsey",
      "GN": "Guinea",
      "GW": "Guinea-Bisau",
      "GY": "Guyana",
      "HT": "Haiti",
      "HM": "Isole Heard e McDonald",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Ungheria",
      "IS": "Islanda",
      "IN": "India",
      "ID": "Indonesia",
      "IR": "Iran",
      "IQ": "Iraq",
      "IE": "Irlanda",
      "IM": "Isola di Man",
      "IL": "Israele",
      "IT": "Italia",
      "JM": "Giamaica",
      "JP": "Giappone",
      "JE": "Jersey",
      "JO": "Giordania",
      "KZ": "Kazakistan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Kuwait",
      "KG": "Kirghizistan",
      "LA": "Laos",
      "LV": "Lettonia",
      "LB": "Libano",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libia",
      "LI": "Liechtenstein",
      "LT": "Lituania",
      "LU": "Lussemburgo",
      "MO": "Macao (Cina)",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malesia",
      "MV": "Maldive",
      "ML": "Mali",
      "MT": "Malta",
      "MQ": "Martinica",
      "MR": "Mauritania",
      "MU": "Mauritius",
      "YT": "Mayotte",
      "MX": "Messico",
      "MD": "Moldavia",
      "MC": "Monaco",
      "MN": "Mongolia",
      "ME": "Montenegro",
      "MS": "Montserrat",
      "MA": "Marocco",
      "MZ": "Mozambico",
      "MM": "Myanmar (Birmania)",
      "NA": "Namibia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NL": "Paesi Bassi",
      "AN": "Antille Olandesi",
      "NC": "Nuova Caledonia",
      "NZ": "Nuova Zelanda",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigeria",
      "NU": "Niue",
      "NF": "Isola Norfolk",
      "KP": "Corea del Nord",
      "MK": "Macedonia del Nord",
      "NO": "Norvegia",
      "OM": "Oman",
      "PK": "Pakistan",
      "PS": "Territori Palestinesi",
      "PA": "Panama",
      "PG": "Papua Nuova Guinea",
      "PY": "Paraguay",
      "PE": "Perù",
      "PH": "Filippine",
      "PN": "Isole Pitcairn",
      "PL": "Polonia",
      "PT": "Portogallo",
      "QA": "Qatar",
      "RE": "Riunione",
      "RO": "Romania",
      "RU": "Russia",
      "RW": "Ruanda",
      "WS": "Samoa",
      "SM": "San Marino",
      "ST": "São Tomé e Príncipe",
      "SA": "Arabia Saudita",
      "SN": "Senegal",
      "RS": "Serbia",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapore",
      "SX": "Sint Maarten",
      "SK": "Slovacchia",
      "SI": "Slovenia",
      "SB": "Isole Salomone",
      "SO": "Somalia",
      "ZA": "Sudafrica",
      "KR": "Corea del Sud",
      "SS": "Sudan del Sud",
      "ES": "Spagna",
      "LK": "Sri Lanka",
      "SD": "Sudan",
      "SR": "Suriname",
      "SJ": "Svalbard e Jan Mayen",
      "SE": "Svezia",
      "CH": "Svizzera",
      "SY": "Siria",
      "TW": "Taiwan",
      "TJ": "Tajikistan",
      "TZ": "Tanzania",
      "TH": "Thailandia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinidad e Tobago",
      "TN": "Tunisia",
      "TR": "Turchia",
      "TM": "Turkmenistan",
      "TC": "Isole Turks e Caicos",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ucraina",
      "AE": "Emirati Arabi Uniti",
      "GB": "Regno Unito",
      "US": "Stati Uniti",
      "UY": "Uruguay",
      "UZ": "Uzbekistan",
      "VU": "Vanuatu",
      "VA": "Città del Vaticano",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis e Futuna",
      "EH": "Sahara Occidentale",
      "YE": "Yemen",
      "ZM": "Zambia",
      "ZW": "Zimbabwe"
    },
    fr: {
      "AF": "Afghanistan",
      "AX": "Îles Åland",
      "AL": "Albanie",
      "DZ": "Algérie",
      "AD": "Andorre",
      "AO": "Angola",
      "AI": "Anguila",
      "AG": "Antigua-et-Barbuda",
      "AR": "Argentine",
      "AM": "Arménie",
      "AW": "Aruba",
      "AC": "Ascension",
      "AU": "Australie",
      "AT": "Autriche",
      "AZ": "Azerbaïdjan",
      "BS": "Bahamas",
      "BH": "Bahreïn",
      "BD": "Bangladesh",
      "BB": "Barbade",
      "BY": "Biélorussie",
      "BE": "Belgique",
      "BZ": "Belize",
      "BJ": "Bénin",
      "BM": "Bermudes",
      "BT": "Bhoutan",
      "BO": "Bolivie",
      "BA": "Bosnie-Herzégovine",
      "BW": "Botswana",
      "BV": "Île Bouvet",
      "BR": "Brésil",
      "IO": "Territoire britannique de l'océan Indien",
      "VG": "Îles Vierges britanniques",
      "BN": "Brunei",
      "BG": "Bulgarie",
      "BF": "Burkina Faso",
      "BI": "Burundi",
      "KH": "Cambodge",
      "CM": "Cameroun",
      "CA": "Canada",
      "CV": "Cap-Vert",
      "BQ": "Pays-Bas caribéens",
      "KY": "Îles Caïmans",
      "CF": "République centrafricaine",
      "TD": "Tchad",
      "CL": "Chili",
      "CN": "Chine",
      "CX": "Île Christmas",
      "CC": "Îles Cocos (Keeling)",
      "CO": "Colombie",
      "KM": "Comores",
      "CG": "Congo-Brazzaville",
      "CD": "Congo-Kinshasa",
      "CK": "Îles Cook",
      "CR": "Costa Rica",
      "CI": "Côte d'Ivoire",
      "HR": "Croatie",
      "CU": "Cuba",
      "CW": "Curaçao",
      "CY": "Chypre",
      "CZ": "République tchèque",
      "DK": "Danemark",
      "DJ": "Djibouti",
      "DM": "Dominique",
      "DO": "République dominicaine",
      "EC": "Équateur",
      "EG": "Égypte",
      "SV": "Salvador",
      "GQ": "Guinée équatoriale",
      "ER": "Érythrée",
      "EE": "Estonie",
      "SZ": "Eswatini",
      "ET": "Éthiopie",
      "FK": "Îles Malouines",
      "FO": "Îles Féroé",
      "FJ": "Fidji",
      "FI": "Finlande",
      "FR": "France",
      "GF": "Guyane française",
      "PF": "Polynésie française",
      "TF": "Terres australes et antarctiques françaises",
      "GA": "Gabon",
      "GM": "Gambie",
      "GE": "Géorgie",
      "DE": "Allemagne",
      "GH": "Ghana",
      "GI": "Gibraltar",
      "GR": "Grèce",
      "GL": "Groenland",
      "GD": "Grenade",
      "GP": "Guadeloupe",
      "GU": "Guam",
      "GT": "Guatemala",
      "GG": "Guernesey",
      "GN": "Guinée",
      "GW": "Guinée-Bissau",
      "GY": "Guyane",
      "HT": "Haïti",
      "HM": "Îles Heard et McDonald",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hongrie",
      "IS": "Islande",
      "IN": "Inde",
      "ID": "Indonésie",
      "IR": "Iran",
      "IQ": "Irak",
      "IE": "Irlande",
      "IM": "Île de Man",
      "IL": "Israël",
      "IT": "Italie",
      "JM": "Jamaïque",
      "JP": "Japon",
      "JE": "Jersey",
      "JO": "Jordanie",
      "KZ": "Kazakhstan",
      "KE": "Kenya",
      "KI": "Kiribati",
      "XK": "Kosovo",
      "KW": "Koweït",
      "KG": "Kirghizistan",
      "LA": "Laos",
      "LV": "Lettonie",
      "LB": "Liban",
      "LS": "Lesotho",
      "LR": "Liberia",
      "LY": "Libye",
      "LI": "Liechtenstein",
      "LT": "Lituanie",
      "LU": "Luxembourg",
      "MO": "Macao (Chine)",
      "MG": "Madagascar",
      "MW": "Malawi",
      "MY": "Malaisie",
      "MV": "Maldives",
      "ML": "Mali",
      "MT": "Malte",
      "MQ": "Martinique",
      "MR": "Mauritanie",
      "MU": "Maurice",
      "YT": "Mayotte",
      "MX": "Mexique",
      "MD": "Moldavie",
      "MC": "Monaco",
      "MN": "Mongolie",
      "ME": "Monténégro",
      "MS": "Montserrat",
      "MA": "Maroc",
      "MZ": "Mozambique",
      "MM": "Myanmar (Birmanie)",
      "NA": "Namibie",
      "NR": "Nauru",
      "NP": "Népal",
      "NL": "Pays-Bas",
      "AN": "Antilles néerlandaises",
      "NC": "Nouvelle-Calédonie",
      "NZ": "Nouvelle-Zélande",
      "NI": "Nicaragua",
      "NE": "Niger",
      "NG": "Nigéria",
      "NU": "Niue",
      "NF": "Île Norfolk",
      "KP": "Corée du Nord",
      "MK": "Macédoine du Nord",
      "NO": "Norvège",
      "OM": "Oman",
      "PK": "Pakistan",
      "PS": "Territoires palestiniens",
      "PA": "Panama",
      "PG": "Papouasie-Nouvelle-Guinée",
      "PY": "Paraguay",
      "PE": "Pérou",
      "PH": "Philippines",
      "PN": "Îles Pitcairn",
      "PL": "Pologne",
      "PT": "Portugal",
      "QA": "Qatar",
      "RE": "Réunion",
      "RO": "Roumanie",
      "RU": "Russie",
      "RW": "Rwanda",
      "WS": "Samoa",
      "SM": "Saint-Marin",
      "ST": "Sao Tomé-et-Principe",
      "SA": "Arabie Saoudite",
      "SN": "Sénégal",
      "RS": "Serbie",
      "SC": "Seychelles",
      "SL": "Sierra Leone",
      "SG": "Singapour",
      "SX": "Saint-Martin",
      "SK": "Slovaquie",
      "SI": "Slovénie",
      "SB": "Îles Salomon",
      "SO": "Somalie",
      "ZA": "Afrique du Sud",
      "KR": "Corée du Sud",
      "SS": "Soudan du Sud",
      "ES": "Espagne",
      "LK": "Sri Lanka",
      "SD": "Soudan",
      "SR": "Suriname",
      "SJ": "Svalbard et Jan Mayen",
      "SE": "Suède",
      "CH": "Suisse",
      "SY": "Syrie",
      "TW": "Taïwan",
      "TJ": "Tadjikistan",
      "TZ": "Tanzanie",
      "TH": "Thaïlande",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TK": "Tokelau",
      "TO": "Tonga",
      "TT": "Trinité-et-Tobago",
      "TN": "Tunisie",
      "TR": "Turquie",
      "TM": "Turkménistan",
      "TC": "Îles Turks-et-Caïques",
      "TV": "Tuvalu",
      "UG": "Ouganda",
      "UA": "Ukraine",
      "AE": "Émirats arabes unis",
      "GB": "Royaume-Uni",
      "US": "États-Unis",
      "UY": "Uruguay",
      "UZ": "Ouzbékistan",
      "VU": "Vanuatu",
      "VA": "Vatican",
      "VE": "Venezuela",
      "VN": "Vietnam",
      "WF": "Wallis-et-Futuna",
      "EH": "Sahara occidental",
      "YE": "Yémen",
      "ZM": "Zambie",
      "ZW": "Zimbabwe"
    }
  }



  let language = 'es';
  if(window.location.pathname.includes("/en/pages/register")) {
    language = 'en';
  // }else if(window.location.pathname.includes("/fr/pages/formulaire-dinscription")) {
  }else if(window.location.pathname.includes("/fr/pages/register")) {
    language = 'fr';
  // }else if(window.location.pathname.includes("/it/pages/modulo-di-registrazione")) {
  }else if(window.location.pathname.includes("/it/pages/register")) {
    language = 'it';
  }
  let countryList = Object.keys(countryNames[language]);
  $("#country-list li").each((i, item) => {
      let countryCode = countryList[i];
      let countryName = countryNames[language][countryCode];
      $(item).text(countryName);
      $(item).attr("value", countryCode);
      $(item).click(e => {
        e.preventDefault();
        $("#country-field-input").val(countryNames[language][$(item).attr("value")])
        $("#country-field").val($(item).attr("value"));
      })
  })
}
  setTimeout(() =>{
    function handleButtonClick(e) {
      e.preventDefault();
      const $button = $(this);
      $button.css({'pointer-events': 'none', 'opacity': '0.6'});
      setTimeout(() =>{
        $button.css({'pointer-events': 'unset', 'opacity': '1'})
      }, 2000);
    }
   
   $(document).on('click dblclick', '.cart  .button-primary', handleButtonClick);
  }, 500)

  BSS_B2B.customTriggerCheckoutBtn = function(){
    window.location.href = '/checkout'
  }
  
  // if(BSS_B2B.shopModules.filter(i => i.code === "form")[0] && BSS_B2B.shopModules.filter(i => i.code === "form")[0].status == 1) {
  //   if(window.location.pathname.includes('en/account/register')) {
  //     window.location.href = "https://bepapaia.com/en/pages/register"
  //   } else if(window.location.pathname.includes('/account/register')) {
  //     window.location.href = "/pages/register"
  //   }
  // }

}

if(location.pathname.includes("/collections/") && !location.pathname.includes("/products/")) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      if(BSS_B2B && BSS_B2B.cp) {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
      }
    }, 1000)
    setTimeout(function () {
      if(BSS_B2B && BSS_B2B.cp.productAfterUseCP.length > 0) {
        const customUnitPriceElements = document.querySelectorAll(".productitem--info [bss-b2b-custom-unit-price-4927]");
        const productAfterUseCPMap = new Map(BSS_B2B.cp.productAfterUseCP.map((item) => [item.id, item]))
        customUnitPriceElements.forEach(function (customUnitPriceElement) {
          const originalPriceElement = customUnitPriceElement.querySelector("del.bss-b2b-customized-original-price");
          const priceElement = customUnitPriceElement.querySelector("span[bss-b2b-product-id][bss-b2b-variant-id][bss-b2b-variant-price]");
          const productId = Number(priceElement.getAttribute("bss-b2b-product-id"));
          const variantId = Number(priceElement.getAttribute("bss-b2b-variant-id"));
          const checkAppliedCP = productAfterUseCPMap.get(productId)?.appliedVariantIds.includes(variantId);
          
          if (checkAppliedCP && originalPriceElement) {
            originalPriceElement.classList.remove("hide-original-price");
          }
        })
      }
    }, 1000)
  })
}

if(location.pathname.includes("/products/")) {
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
      changeProductPrice();
      if(BSS_B2B && BSS_B2B.cp.productAfterUseCP.length > 0) {
        const originalPriceElement = document.querySelector(".price--main del.bss-b2b-customized-original-price");
        const priceElement = document.querySelector(".price--main span[bss-b2b-product-id][bss-b2b-variant-id][bss-b2b-variant-price]");
        const productAfterUseCPMap = new Map(BSS_B2B.cp.productAfterUseCP.map((item) => [item.id, item]))
        const productId = Number(priceElement.getAttribute("bss-b2b-product-id"));
        const variantId = Number(priceElement.getAttribute("bss-b2b-variant-id"));
        const checkAppliedCP = productAfterUseCPMap.get(productId)?.appliedVariantIds.includes(variantId);
        
        if (checkAppliedCP && originalPriceElement) {
          originalPriceElement.classList.remove("hide-original-price");
        }
      }
    }, 1000)
    const variantSelector = document.querySelector("select#static-product-form-0data-product-option-0");
    if(variantSelector){
    variantSelector.addEventListener("change", ()=>{
        changeProductPrice();
    })
    }
  })
}

function changeProductPrice() {
    const price = document.querySelector(".price--main span");
    const comparePrice = document.querySelector(".bss-b2b-customized-original-price.hide-original-price");
    if(comparePrice) comparePrice.remove();
    if(price){
      price.removeAttribute("bss-b2b-product-active");
      price.setAttribute("bss-b2b-featured-product", "true");
    }
    setTimeout(() =>{
      const url = new URL(window.location.href);
      const variantId = url.searchParams.get('variant');
      BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,".price--main span", false, false, variantId);
    }, 50)
}

document.addEventListener("BSS:changeVariant", e => {
  BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0,0);
});

document.addEventListener('DOMContentLoaded', () => {
  const targetElement = document.getElementById('site-mobile-nav');

  if(targetElement) {
    const observer = new MutationObserver((mutations) => {
      // console.log(mutations);
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (targetElement.classList.contains('visible')) {
            $('.bss-currency-wrapper').attr('style', 'display: block !important');
          }
        }
        // if (item.target.classList.contains('t4s-modal__content')) {

        // }
      });
    });
    
    observer.observe(targetElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
})
